<template>
<div class="chapter">
<div class="inner_page">
<p class="author"><a id="pageiii"></a>VAL McDERMID</p>
<p class="title"><img alt="" src="OEBPS/images/tp.png"/><br/><strong>FINAL EDITION</strong><br/><span class="tp">AND</span><br/><strong>UNION JACK</strong><br/><img alt="" src="OEBPS/images/tp.png"/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?89baeeb2